const taskTemplates = require('../../task-templates');

const tasksData = [
	/* Case 1 */
	Object.assign({}, taskTemplates.inputAnswerTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 1,
		title: 'Opgave 1',
		taskId: 'education-input-stx',
		text: `HF er en forkortelse – hvad står bogstaverne for?`,
		hintText: `Det kan googles ret hurtigt.`,
		popupText: `HF giver adgang til mange videregående uddannelser i Danmark.`,
		answer: 'Højere forberedelseseksamen',
		altAnswers: ['Højre Forberedelseseksamen'],
		subtype: 'string',
		unit: null,
		image: 'stx-hat'
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 2,
		title: 'Opgave 2',
		taskId: 'education-mc-stx-duration',
		text: `Hvor mange år tager en HF-uddannelse som udgangspunkt?`,
		hintText: `I kan nemt finde svaret her: 
			<br /><br />https://www.ug.dk/uddannelser-til-unge/gymnasiale-uddannelser/hf-eksamen-hf`,
		popupText: `En gymnasieuddannelse er bygget op, så man både når at have grundforløb og fordybelse i fagene.`,
		image: 'stx-classroom-female-student',
		shuffleOptions: false,
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: '1 år'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, text: '2 år', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3, text: '3 år'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4, text: '4 år'
			})
		],
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 3,
		subtype: 'images',
		title: 'Opgave 3',
		taskId: 'education-mc-cool-school-items',
		text: `I skal i skole på %school%! Hvilket udstyr tror I, I skal have med for at være klar til en dag med fag og projekter?`,
		hintText: `Det handler om ting, man bruger hver dag i undervisningen.`,
		popupText: `Gymnasiet handler ikke kun om bøger – gruppearbejde, teknologi og fælles projekter fylder også meget.`,
		layout: 'stx-cool-school-items',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'laptop', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'books', isCorrect: true
			}),
			// Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
			// 	id: 'group-work', isCorrect: true
			// }),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'phone'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'money',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'smartboard', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'chefs-hat',
			}),
		],
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 4,
		title: 'Opgave 4',
		taskId: 'education-mc-stx-students',
		text: `Hvor mange elever tror I, der cirka starter på HF hvert år i Danmark?`,
		hintText: `Hvis der starter én eller flere HF-klasser på mange skoler, hvor mange elever giver det tilsammen?`,
		popupText: `HF er en gymnasial uddannelse, som hvert år optager tusindvis af elever.`,
		image: 'stx-graduation-throw-hats',
		shuffleOptions: false,
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: 'Ca. 2.000'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, text: 'Ca. 4.000',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3, text: 'Ca. 8.000', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4, text: 'Ca. 16.000'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 6, text: 'Ingen ved det, men alle taler om det'
			})
		],
	}),
	/* Case 2 */
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 1,
		title: 'Opgave 1',
		taskId: 'education-mc-3-characteristics',
		text: `Hvilke tre ting tror I, bedst beskriver elever, der vælger HF?`,
		hintText: `I kan nemt finde svaret her: 
			<br /><br />https://www.ug.dk/uddannelser-til-unge/gymnasiale-uddannelser/hf-eksamen-hf`,
		popupText: `HF tiltrækker mange forskellige elever – fælles er, at undervisningen kombinerer faglig viden med virkelige problemstillinger.`,
		image: 'stx-male-student',
		shuffleOptions: false,
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: 'De vil gerne lære ved at bruge fagene på virkelige problemer', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, text: 'De foretrækker praktisk arbejde og laberatorie samt værkstedsopgaver',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3, text: 'De kan lide undervisning, hvor man både arbejder med teori og praksis', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4, text: 'De trives bedst med korte lektioner og få hjemmearbejdsopgaver'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 5, text: 'De ved, at en uddannelse kræver forberedelse og arbejde uden for undervisningen', isCorrect: true
			})
		],
	}),
	Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 2,
		taskId: 'education-sort-basic',
		title: 'Opgave 2',
		text: `Når I er nye på HF, skal I finde ud af, hvad der sker i starten af uddannelsen.
			<br />Kan I sortere det, der hører med, fra det, der ikke gør?`,
		hintText: `I kan nemt finde svaret her: 
			<br /><br />https://www.ug.dk/uddannelser-til-unge/gymnasiale-uddannelser/hf-eksamen-hf`,
		popupText: `Grundforløbet er den første tid på gymnasiet, hvor alle prøver fag og studieretninger, før man vælger sin endelige retning.`,
		layout: 'education-sort-basic',
		categories: [
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'true', title: `Sandt om grundforløbet`}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'false', title: `Falsk om grundforløbet`})
		],
		items: [
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 1, text: `Introduktion til fag og studieretninger`, categoryIds: ['true']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 2, text: `HF har ikke et grundforløb`, categoryIds: ['true']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 3, text: `HF starter direkte med de fag, man skal have`, categoryIds: ['true']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 4, text: `Introduktion til alle gymnasiets undervisere og vejledere`, categoryIds: ['false']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 5, text: `Grundforløbet starter allerede efter de første 3 måneder`, categoryIds: ['false']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 6, text: `Man vælger selv, hvilke fag man skal have på grundforløbet`, categoryIds: ['false']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 7, text: `Under grundforløbet skal man besøge videregående uddannelser`, categoryIds: ['false']}),
		]
	}),
	Object.assign({}, taskTemplates.orderTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 3,
		taskId: 'education-order-visit',
		title: 'Opgave 3',
		text: `I dag handler det om %school%. Hvad tror I, er de bedste ting at gøre, hvis %school% virker spændende? Sæt dem i den rækkefølge, I synes giver mest mening.`,
		hintText: `Det er i hvert falde en god ide at besøge et åbent hus.`,
		popupText: `Mange elever finder først ud af, om HF er noget for dem, når de har været til åbent hus.`,
		layout: 'halfdouble-height',
		items: [
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 1, text: `Prøve kræfter med %school%s HF spil.`, correctOrderNumbers: [1]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 2, text: `Skrive sig op til åbent hus direkte i spillet, når det er færdigt`, correctOrderNumbers: [2]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 3, text: `Læse mere på uddannelsesguiden - www.ug.dk`, correctOrderNumbers: [3]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 4, text: `Tale med sin vejleder og lærere`, correctOrderNumbers: [4]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 5, text: `Tage mor og far med til åbent hus`, correctOrderNumbers: [5]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 6, text: `Beslutte sig i god tid og ansøge`, correctOrderNumbers: [6]
			})
		]
	}),
	/* Case 3 */
	Object.assign({}, taskTemplates.orderTemplate.mainTemplate, {
		caseId: 3,
		taskNumber: 1,
		taskId: 'education-order-university-job',
		title: 'Opgave 1',
		text: `Hvad tror I er rækkefølgen for en gymnasieelev, der drømmer om et job med en universitetsuddannelse? Sæt trinnene i rigtig rækkefølge – fra start til slut.`,
		hintText: `Start med skolen og slut med jobbet.`,
		popupText: `Det kan tage mange år fra man starter på gymnasiet, til man står færdig som fx læge eller jurist – men gymnasiet er et godt sted at begynde.`,
		layout: 'halfdouble-height',
		items: [
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 1, text: `Færdiggøre grundskolen`, correctOrderNumbers: [1]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 2, text: `Begynde på gymnasiet`, correctOrderNumbers: [2]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 3, text: `Vælge studieretning og fagpakke`, correctOrderNumbers: [3]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 4, text: `Gennemføre gymnasieeksamen`, correctOrderNumbers: [4]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 5, text: `Fuldføre videregående uddannelse`, correctOrderNumbers: [5]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 6, text: `Starte i job`, correctOrderNumbers: [6]
			})
		]
	}),
	Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
		caseId: 3,
		taskNumber: 2,
		taskId: 'education-sort-dreams',
		title: 'Opgave 2A',
		text: `Hvilke jobs og karrierer tror I, mange HF-elever går og drømmer om?`,
		hintText: `ChatGPT kan hjælpe jer godt på vej.`,
		popupText: `HF-elever drømmer ofte om job, hvor man bruger sin viden i praksis og gør en forskel for andre.`,
		categories: [
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'typical', title: `Typiske drømme`}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'notTypical', title: `Ikke typiske drømme`})
		],
		items: [
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 1, text: `Læge`, categoryIds: ['typical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 2, text: `Pædagog`, categoryIds: ['typical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 3, text: `Sygeplejerske`, categoryIds: ['typical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 4, text: `Politibetjent`, categoryIds: ['typical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 5, text: `Lærer`, categoryIds: ['typical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 6, text: `Arkitekt`, categoryIds: ['typical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 7, text: `Fysioterapeut`, categoryIds: ['typical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 8, text: `Frisør`, categoryIds: ['notTypical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 9, text: `Programmør`, categoryIds: ['notTypical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 10, text: `Revisor`, categoryIds: ['notTypical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 11, text: `Marketingchef`, categoryIds: ['notTypical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 12, text: `Økonom`, categoryIds: ['notTypical']})
		]
	}),
	Object.assign({}, taskTemplates.paperDollTemplate.mainTemplate, {
		caseId: 3,
		taskNumber: 3,
		title: 'Opgave 2B',
		taskId: 'education-paper-doll-doctor',
		lockedById: 'education-sort-dreams',
		layout: 'education-doctor',
		avatarId: 'avatar-1',
		text: `Et af jobbene, vi nævnte, var læge. Hvilket udstyr tror I, man bruger som læge? Vælg de ting, der passer bedst – og klik OK, når I synes, I har ramt rigtigt.`,
		hintText: `Tænk på, hvad en læge bruger i hverdagen.`,
		items: [
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'syringe-b', title: 'Sprøjte med nål', isCorrect: true
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'lab-coat-white', title: 'Hvid kittel', isCorrect: true
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'chart', title: 'Notatblok til journalføring', isCorrect: true
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'camera-b', title: 'Kamera'
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'paint-brush', title: 'Malerpensel'
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'safety-shoes', title: 'Sikkerhedssko'
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'stethoscope', title: 'Stetoskop', isCorrect: true
			})
		]
	}),
	Object.assign({}, taskTemplates.spotErrorsTemplate.mainTemplate, {
		caseId: 3,
		taskNumber: 4,
		title: 'Opgave 3',
		taskId: 'education-spot-errors-job-event',
		layout: 'education-job-event',
		text: `Mange gymnasieelever tager til jobmesser og karriereevents. På billedet ser I en elev til en jobmesse – men der er nogle ting, der ikke helt passer. Kan I finde dem? Klik OK, når I tror, I har alle.`,
		hintText: `Kig på ting, der virker forkerte i et professionelt møde.`,
		errors: [
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'tie'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'lamp'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'chair'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'paper'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'cup'})
		]
	}),
	Object.assign({}, taskTemplates.inputAnswerTemplate.mainTemplate, {
		caseId: 3,
		taskNumber: 5,
		title: 'Opgave 4',
		taskId: 'education-input-limits',
		text: `Hvis man vælger HF, sætter det så grænser for, hvad man kan blive i fremtiden?`,
		hintText: `Gå med jeres fornemmelse.`,
		popupText: `I Danmark har man altid mulighed for at skifte retning efter sin ungdomsuddannelse. Hvis der mangler fag til en bestemt videregående uddannelse, kan man supplere med enkeltfag og tilpasse sin vej undervejs. `,
		answer: 'Nej',
		subtype: 'string',
		unit: null
	}),
];

let taskIdsArr = [];
tasksData.forEach((task, index) => {
	/* Assign unique id used for navigation */
	task.id = 'stxhf-edu-' + (index + 1 < 10 ? '0' : '') + (index + 1);

	/* Check taskId is set when required and unique */
	if (task.taskId) {
		if (taskIdsArr.indexOf(task.taskId) >= 0) {
			console.error('Task id not unique: ', task.taskId);
		} else {
			taskIdsArr.push(task.taskId);
		}
	} else {
		console.error('Missing task id for task: ', task);
	}
});

export {
	tasksData
};